// チケット消費量の計算方式
export type TicketCalculationType = 'fixed' | 'per_duration';

export const TICKET_CALCULATION_TYPES = {
  FIXED: 'fixed',
  PER_DURATION: 'per_duration',
} as const;

// チケットプラン・コース紐付け
export type NewTicketPlanCourse = {
  ticketPlanId: number;
  courseId: number;
  requiredAmount: number;
  calculationType: TicketCalculationType;
  perDurationMinutes: number | null;
  perDurationAmount: number | null;
};

export type TicketPlanCourse = NewTicketPlanCourse & {
  id: number;
  createdAt: string;
  updatedAt: string;
};

/**
 * チケット消費量を計算する
 * @param ticketPlanCourse チケットプラン・コース紐付け情報
 * @param minutesRequired 所要時間（分）
 * @returns 消費量
 */
export const calculateTicketConsumption = (
  ticketPlanCourse: Pick<
    TicketPlanCourse,
    | 'calculationType'
    | 'requiredAmount'
    | 'perDurationMinutes'
    | 'perDurationAmount'
  >,
  minutesRequired: number | null
): number => {
  // 所要時間ベースの計算
  if (
    ticketPlanCourse.calculationType === 'per_duration' &&
    ticketPlanCourse.perDurationMinutes &&
    ticketPlanCourse.perDurationAmount &&
    minutesRequired
  ) {
    return Math.ceil(
      (minutesRequired / ticketPlanCourse.perDurationMinutes) *
        ticketPlanCourse.perDurationAmount
    );
  }

  // 固定値
  return ticketPlanCourse.requiredAmount;
};
